import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    versionType:"",
    vehicleType: ""
  },
  getters: {
  },
  mutations: {
    changeVersionType(state,payload){
      console.log('changeVersionType',payload)
      state.versionType = payload
    },
    changeVehicleType(state,payload){
      console.log('changeVehicleType',payload)
      state.vehicleType = payload
    }
  },
  actions: {
  
  },
  modules: {
  }
})
